export default "__VITE_ASSET__edKO8b1V__"